import React, { useEffect } from 'react';
import { useDataEdit } from 'hooks/use-data-edit';
import { useTopNav } from 'components/common/top-nav/hooks';
import { redirect } from 'lib/location';
import { useEntityLogs } from 'components/common/entity-logs/hooks';
import { useTable } from 'components/common/table/hooks';

export const useProfile = ({ pageProps }) => {
  const { _id, mode, collection, metadata, isLoading, isEditMode, isCopyMode } = pageProps;
  const { contractData, contractUserData, contractDataIsLoading, refetchContractData } = useContractData({ _id });
  const url = isEditMode
    ? `/api/collection/${collection}/edit/${_id}`
    : isCopyMode
    ? `/api/collection/${collection}/copy/${_id}`
    : `/api/collection/${collection}/register`;

  const { Component: EntityLogs, refetch: refetchLogs } = useEntityLogs({ _id });
  const { setTopNav } = useTopNav();
  const { data, config, controller, save, canSave } = useDataEdit({
    mode,
    value: pageProps,
    config: { editable: false, ...pageProps },
    url,
    refetch: () => {
      pageProps?.fetchPageData();
      refetchContractData();
      refetchLogs();
    },
    success:
      mode === 'new' || mode === 'copy'
        ? (result) => {
            if (result && result?._id) {
              redirect(`/user/profile/${result._id}`);
            }
          }
        : undefined
  });

  const { schema, fieldsToDisplay = [], isEdit } = config;
  const { setInputs } = controller;

  useEffect(() => {
    const copy = isEdit
      ? () => {
          redirect(`/user/copy/${_id}`);
        }
      : null;
    const title = `${config?.title} ${data?.nickname ? '(' + data?.nickname + ')' : ''} `;
    setTopNav({ save, canSave, copy, title });
  }, [save, canSave, isEdit, _id, data, config]);

  return {
    _id,
    data,
    contractDataIsLoading,
    contractData,
    contractUserData,
    config,
    controller,
    save,
    canSave,
    schema,
    fieldsToDisplay,
    setInputs,
    metadata,
    isLoading,
    EntityLogs
  };
};

export const useContractData = (props) => {
  const { _id } = props;
  const {
    controllers: contractDataControllers,
    data: contractData = [],
    isLoading: contractDataIsLoading
  } = useTable({
    url: '/api/collection/contract/listing',
    paramsPreset: {
      pageSize: 10000
    }
  });
  const {
    controllers: contractUserDataControllers,
    data: contractUserData = [],
    isLoading: contractUserDataIsLoading
  } = useTable({
    url: '/api/collection/contract-user/listing',
    paramsPreset: {
      pageSize: 10000,
      filters: [
        {
          field: 'user',
          op: 'eq',
          value: _id
        }
      ]
    }
  });

  return {
    refetchContractData: () => {
      contractDataControllers.refetch();
      contractUserDataControllers.refetch();
    },
    contractData,
    contractUserData,
    contractDataIsLoading: contractUserDataIsLoading || contractDataIsLoading
  };
};
